export default "__VITE_ASSET__PnQO_1Fn__"